var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.targetId)?_c('b-popover',{ref:"popover",attrs:{"target":_vm.targetId,"triggers":"hover","placement":_vm.placement,"html":true,"custom-class":"popover-lg"}},[_c('div',{},[_vm._v(" "+_vm._s(_vm.info)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }